module.exports = (callback) => {
    callback();
    document.body.classList.remove('preload');
};